
export default {

    SET_TOKEN: (state, token) => {
        state.token = token
      },
    // 用户相关 mutations
    SET_USER_DATA(state, userData) {
        state.user = {
          userName: userData.userName,
          password: userData.password,
          recommendUserId: userData.recommendUserId,
          isAuthenticated: true
      }
    },
    
    CLEAR_USER_DATA(state) {
      state.user = {
        userName: '',
        password: '',
        recommendUserId: '',
        isAuthenticated: false
      }
      state.token = null
    },
    UPDATE_WALLET(state, wallet) {
      state.wallet = wallet
    },
    
    // 筛选相关 mutations
    UPDATE_SEARCH_QUERY(state, query) {
      state.filters.searchQuery = query
    },
    
    UPDATE_INDUSTRYTYPE(state, industryType) {
      state.filters.industryType = industryType
    },
    UPDATE_INDUSTRYTYPE(state, journaLevel) {
      state.filters.journaLevel = journaLevel
    },
    UPDATE_PUBLICATIONCYCLE(state, publicationCycle) {
      state.filters.publicationCycle = publicationCycle
    },
    UPDATE_JOURNALBATCH(state, journalBatch) {
      state.filters.journalBatch = journalBatch
    },
    UPDATE_COLLECTIONSOURCE(state, collectionSource) {
      state.filters.collectionSource = collectionSource
    },
    
    RESET_FILTERS(state) {
      state.filters = {
        industryType: [],
        journaLevel: [],
        publicationCycle: [],
        journalBatch: [],
        collectionSource: []
      }
    }
  }